import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class UploadService {
	pendingFiles: File[] = [];
	pendingFilesObservableOutput = new Observable<File[]>();
	private pendingFilesObservableInput: Subject<File[]>;

	constructor() {
		this.pendingFilesObservableInput = new Subject<File[]>();
		this.pendingFilesObservableOutput = this.pendingFilesObservableInput.asObservable();
	}

	setPendingFiles(files: File[]): void {
		this.pendingFiles = files;
	}

	getPendingFiles(): File[] {
		return this.pendingFiles;
	}

	appendUpload(formData: FormData, file: File): void {
		formData.append("filedata", file);
		formData.append("filenames", new Blob([file.name], { type: "text/plain;charset=utf8" }));
	}

	async createFormData(files: File[]): Promise<FormData> {
		const formData = new FormData();
		for (const file of files) {
			formData.append("filenames", new Blob([file.name], { type: "text/plain;charset=utf8" }));
			formData.append("filetypes", new Blob([file.type], { type: "text/plain;charset=utf8" }));
			if (this.needsBase64Encoding(file)) {
				const fileContents = await file.arrayBuffer();

				formData.append("filedata", btoa(String.fromCodePoint(...new Uint8Array(fileContents))));
			} else {
				formData.append("filedata", file);
			}
		}
		return formData;
	}

	// Keep this in sync with needsBase64Decoding in MultiPartUpload.java
	needsBase64Encoding(file: File): boolean {
		return file.type === "message/rfc822";
	}

	setFilesToUpload(files: File[]): void {
		this.pendingFilesObservableInput.next(files);
	}
}
